import React, { Component } from 'react'
import Helmet from 'react-helmet'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})

class MetaTags extends Component {
  constructor(props) {
    super(props)
    window.prerenderReady = false
  }

  componentDidMount() {
    window.prerenderReady = true
  }

  componentWillUnmount() {
    window.prerenderReady = false
  }

  render() {
    const {
      h1, h2, h3, event_url,
      eventStartTime,
      title,
      description,
      keywords,
      url,
      type,
      image_id,
      facebookDescription,
      ogDescription,
      fetch,
      notShowKeywords,
      setPrerenderStatusCode
    } = this.props

    let imageParams = {
      gravity: 'center',
      height: 630,
      width: 1200,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    }

    if (fetch === true) {
      imageParams = {
        gravity: 'center',
        height: 630,
        width: 1200,
        crop: 'fill',
        format: 'jpg',
        type: 'fetch',
        quality: 80,
      }
    }

    function getFormattedUrl(url) {
      let newUrl = url

      if (event_url) {
        return event_url
      }

      if (!url || url.length === 0) {
        return newUrl = 'https://www.twistedroad.com'
      }

      if (url.includes('https://www.twistedroad.com')) {
        newUrl = url
      }

      if (url.includes('http://localhost:3000')) {
        newUrl = url.replace(
          'http://localhost:3000',
          'https://www.twistedroad.com'
        )
      }

      if (url.includes('https://frontend.staging.twistedroad.com')) {
        newUrl = url.replace(
          'https://frontend.staging.twistedroad.com',
          'https://www.twistedroad.com'
        )
      }

      if (url.includes('https://frontend.golive.twistedroad.com')) {
        newUrl = url.replace(
          'https://frontend.golive.twistedroad.com',
          'https://www.twistedroad.com'
        )
      }

      if (url.charAt(0) === '/') {
        newUrl = 'https://www.twistedroad.com' + url
      }

      return newUrl.toLowerCase()
    }

    return (
      <Helmet>
        <title>{title ? title : 'Twisted Road'}</title>
        <meta
          name="description"
          content={ogDescription ? ogDescription : description.trim()}
        />
        {!notShowKeywords &&
          <meta
            name="keywords"
            content={
              keywords ??
              'motorcycle rental, motorcycle sharing, peer-to-peer motorcycle sharing, motorcycles for rent, rent a motorcycle near me, turo for motorcycles, motorcycle rental app, harley rentals, ducati rentals, triumph rentals, bmw motorcycle rentals, motorbike hire, peer-to-peer motorcycle rentals'
            }
          />
        }
        <link rel="canonical" href={getFormattedUrl(url)} />
        <meta property="og:title" content={title} />
        {h1 && <meta property="og:h1" content={h1} />}
        {h2 && <meta property="og:h2" content={h2} />}
        {h3 && <meta property="og:h3" content={h3} />}
        <meta property="og:url" content={getFormattedUrl(url)} />
        <meta property="og:type" content={type} />
        {eventStartTime && <meta property="og:start_time" content={eventStartTime} />}
        <meta
          property="og:description"
          content={ogDescription ? ogDescription : description.trim()}
        />
        <meta
          property="og:image"
          content={
            image_id == null
              ? 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567107937/frontend_assets/seo/seo-facebook-default.png'
              : cl.url(image_id, imageParams)
          }
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        {setPrerenderStatusCode && (
          <meta name="prerender-status-code" content="404" />
        )}
      </Helmet>
    )
  }
}

export default MetaTags

MetaTags.defaultProps = {
  title: 'Convenient motorcycle rental: #1 most trusted',
  description:
    'Rent any motorcycle you want, wherever you want it, from our nationwide community of local bike owners, or make extra money renting out your motorcycle.',
  url: '',
  type: 'company', //should be:  Company (any page. site wide default also), product(bike listing) or profile (public user profiles)
  image_id: null,
  facebookDescription:
    'Rent any motorcycle you want, wherever you want it, from our nationwide community of local bike owners, or make extra money renting out your motorcycle.',
  fetch: false,
}
